import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { LinkVerificationLoader } from "~/components/feature/spotlight/Loader";
import {
  SpotlightErrorNoData,
} from "~/components/feature/spotlight/SpotlightError";
import { Viewer } from "~/components/feature/spotlight/Viewer";
import { useSpotlightGoldLayerAllData } from "~/hooks/useSpotlightGoldLayer";

export const Route = createFileRoute("/view/$token")({
  component: RouteComponent,
});

function RouteComponent() {
  const { token } = Route.useParams();
  const navigate = useNavigate();

  const endpoint = `/api/v2/gold-layer/spotlights?token=${encodeURIComponent(token)}`;
  const { data: spotlightData, isLoading, hasError, hasNotFound } =
    useSpotlightGoldLayerAllData(endpoint);

  // hasError: Token expirado o error del servidor → redirige a página de error
  useEffect(() => {
    if (!isLoading && hasError) {
      navigate({ to: "/error" });
    }
  }, [isLoading, hasError, navigate]);

  if (isLoading) {
    return <LinkVerificationLoader />;
  }

  // hasNotFound: No hay datos en el spotlight → mensaje de "sin información"
  if (hasNotFound) {
    return <SpotlightErrorNoData />;
  }

  if (!spotlightData) {
    return null;
  }

  return <Viewer spotlightData={spotlightData} />;
}
